var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-button',{staticClass:"btn-twitter btn-second",attrs:{"loading":_vm.loading,"block":"","type":"button","disabled":_vm.isDisabled},on:{"click":function($event){return _vm.initAssign()}}},[_vm._v(" Accept ")])
}
var staticRenderFns = []

export { render, staticRenderFns }